module.exports = __webpack_public_path__ + "img/sim2.1d784359.png";